import { api } from "./configs/axiosConfigs";

export const ClosedBusinessesAPI = {
  getClosedBusinesses: async () => {
    const response = await api.get(
      `/closed_businesses?page=1&items_per_page=2000&order_by=closed_business_date&order=desc`,
    );

    return response?.data;
  },

  getRecurringClosedBusinesses: async () => {
    const response = await api.get(
      `/closed_businesses?page=1&items_per_page=2000&order_by=closed_business_date&order=desc&recurrent=true`,
    );

    return response?.data;
  },

  getClosedBusiness: async (id, type) => {
    const response = await api.get(`/closed_businesses/${type}/${id}`);

    return response?.data;
  },

  addClosedBusiness: async (form, type) => {
    const response = await api.post(`/closed_businesses/${type}`, form);

    return response?.data;
  },

  updateClosedBusiness: async (form, id, type) => {
    const response = await api.patch(`/closed_businesses/${type}/${id}`, form);

    return response?.data;
  },

  deleteClosedBusiness: async (id, invitationType) => {
    const response = await api.delete(
      `/closed_businesses/${invitationType}/${id}`,
    );

    return response?.data;
  },
};
